import React from 'react';
import type { HRPortalPage } from '../types/hrPortalTypes';
import './HRPortalLayout.scss';

interface HRPortalLayoutProps {
  currentPage: HRPortalPage;
  onPageChange: (page: HRPortalPage) => void;
  children: React.ReactNode;
  asPortal?: boolean;
}

interface MenuItem {
  id: HRPortalPage;
  label: string;
  icon?: string;
}

const HRPortalLayout: React.FC<HRPortalLayoutProps> = ({
  currentPage,
  onPageChange,
  children,
  asPortal = false,
}) => {
  const mainMenuItems: MenuItem[] = [
    { id: 'dashboard', label: 'Dashboard', icon: 'bx-grid-alt' },
    { id: 'employees', label: 'Employees', icon: 'bx-user' },
    { id: 'documents', label: 'Documents', icon: 'bx-file' },
    { id: 'reports', label: 'Reports', icon: 'bx-bar-chart-alt-2' },
  ];

  const hrOperationsItems: MenuItem[] = [
    { id: 'onboarding', label: 'Onboarding', icon: 'bx-user-plus' },
    { id: 'attendance', label: 'Attendance', icon: 'bx-calendar-check' },
    { id: 'leave-management', label: 'Leave Management', icon: 'bx-calendar' },
    { id: 'offboarding', label: 'Offboarding', icon: 'bx-user-x' },
  ];

  const handleMenuClick = (pageId: HRPortalPage) => {
    onPageChange(pageId);
  };

  return (
    <div className={`hr-portal-container ${asPortal ? 'hr-portal-as-portal' : ''}`}>
      <div className="hr-portal-sidebar">
        <div className="hr-portal-sidebar-header">
          <h3>HR Portal</h3>
        </div>
        <nav className="hr-portal-nav">
          <div className="hr-portal-menu-section">
            <div className="hr-portal-menu-heading">Main Menu</div>
            <ul className="hr-portal-menu-list">
              {mainMenuItems.map((item) => (
                <li
                  key={item.id}
                  className={`hr-portal-menu-item ${
                    currentPage === item.id ? 'active' : ''
                  }`}
                  onClick={() => handleMenuClick(item.id)}
                >
                  {item.icon && (
                    <i className={`bx ${item.icon} hr-portal-menu-icon`}></i>
                  )}
                  <span>{item.label}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="hr-portal-menu-section">
            <div className="hr-portal-menu-heading">HR Operations</div>
            <ul className="hr-portal-menu-list">
              {hrOperationsItems.map((item) => (
                <li
                  key={item.id}
                  className={`hr-portal-menu-item ${
                    currentPage === item.id ? 'active' : ''
                  }`}
                  onClick={() => handleMenuClick(item.id)}
                >
                  {item.icon && (
                    <i className={`bx ${item.icon} hr-portal-menu-icon`}></i>
                  )}
                  <span>{item.label}</span>
                </li>
              ))}
            </ul>
          </div>
        </nav>
      </div>
      <div className="hr-portal-content">
        {children}
      </div>
    </div>
  );
};

export default HRPortalLayout;
